/*
 * 作者: Fultom
 * 创建时间: 2023-10-20 13:43:19
 * 最近修改时间: 2024-12-17 11:04:57
 * 功能:
 */
const _import = require('./_import_' + process.env.NODE_ENV);

const dataPerformancePage = [

  // 业绩数据
  {
    path: '/performance/list',
    name: 'PerformanceList',
    component: _import('dataPerformance/dataList/index'),
    hidden: true,
    meta: {
      title: '业绩数据',
      noCache: true
    }
  }, {
    path: '/performance/preview',
    name: 'PerformancePreview',
    component: _import('dataPerformance/dataPreview/index'),
    hidden: true,
    title: '业绩预览',
    meta: {
      title: '业绩预览',
      noCache: true
    }
  }, {
    path: '/performance/data/info',
    name: 'PerformanceDataInfo',
    component: _import('dataPerformance/dataInfo/index'),
    hidden: true,
    title: '采购量明细',
    meta: {
      title: '采购量明细',
      noCache: true
    }
  }, {
    path: '/performance/data/goods/info',
    name: 'PerformanceDataGoodsInfo',
    component: _import('dataPerformance/dataGoodsInfo/index'),
    hidden: true,
    title: '商品明细',
    meta: {
      title: '商品明细',
      noCache: true
    }
  }, {
    path: '/performance/data/report',
    name: 'PerformanceDataReport',
    component: _import('dataPerformance/dataReport/index'),
    hidden: true,
    title: '月报表',
    meta: {
      title: '月报表',
      noCache: true
    }
  }, {
    path: '/performance/data/invoice/entry',
    name: 'PerformanceDataInvoiceEntry',
    component: _import('dataPerformance/dataInvoiceEntry/index'),
    hidden: true,
    title: '报销申报',
    meta: {
      title: '报销申报',
      noCache: true
    }
  },
  {
    path: '/performance/reimbursementInfo/list',
    name: 'PerformanceReimbursementInfoList',
    component: _import('dataPerformance/reimbursementInfoList/index'),
    hidden: true,
    title: '报销明细',
    meta: {
      title: '报销明细',
      noCache: true
    }
  },{
    path: '/performance/afterSaleInfo/list',
    name: 'PerformanceAfterSaleInfoList',
    component: _import('dataPerformance/afterSaleInfoList/index'),
    hidden: true,
    title: '售后明细',
    meta: {
      title: '售后明细',
      noCache: true
    }
  },
]

export default dataPerformancePage;



// WEBPACK FOOTER //
// ./src/router/dataPerformance.js